module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_104919002_L-e014005c66bd8d8fd189bf02bc1b5d3c.jpg";